import React, { useEffect } from 'react';
import {
  Grid2 as Grid,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Typography,
  Tooltip,
  Divider,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../Context/authContext';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../context/authContext';
import { Groups2 } from '@mui/icons-material';

const LoggedInAvatar: React.FC = () => {
  const settings = ['Account', 'Dashboard', 'Change Community', 'Logout' ];
  const settingsIcons = ['account_circle', 'dashboard', 'change_community', 'logout'];
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const { user, isAuthenticated, logout } = useAuth();

  const navigate = useNavigate();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOnClick = (setting: string) => {
    if (setting === 'Logout') {
      logout()
      console.log(isAuthenticated);
      navigate('/');
    } else {
      navigate('/' + setting.toLowerCase());
    }
    setAnchorElUser(null);
  };

  return (
    <>
      <Tooltip title="Open settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar alt={user?.first_name} src={user.avatar} />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <Stack spacing={2} direction={'row'} alignItems="center" sx={{p:2}}>
            <Avatar alt={user?.first_name} src={user.avatar} sx={{ width: 50, height: 50, mx: 'auto', my: 2 }} />
            <Typography textAlign="center" variant="h6">
              {user?.first_name} {user?.last_name}
            </Typography>
        </Stack>
        <Divider />
        {settings.map((setting, index) => (
          <MenuItem key={setting} onClick={() => handleOnClick(setting)}>
            <IconButton size="small" sx={{ mr: 1 }}>
              {settingsIcons[index] === 'person' && <PersonIcon />}
              {settingsIcons[index] === 'account_circle' && <AccountCircleIcon />}
              {settingsIcons[index] === 'change_community' && <Groups2 />}
              {settingsIcons[index] === 'dashboard' && <DashboardIcon />}
              {settingsIcons[index] === 'logout' && <LogoutIcon />}
            </IconButton>
            <Typography textAlign="center">{setting}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LoggedInAvatar;
